import React from 'react';
import { Button } from 'semantic-ui-react';
import ReviewModal from '../ReviewModal';
import Security from '../../../utils/Security';

const ReviewButton = ({ job, size = 'medium' }) => {
  const isProjectOwner = Security.isProjectOwner(job.project);
  if (!isProjectOwner) {
    return null;
  }
  const hasReviewed = !!job.ratingOnExpert || !!job.reviewOnExpert;
  return (
    <ReviewModal meeting={job}>
      <Button size={size} className="primary-btn">
        {hasReviewed ? 'Edit Review' : 'Leave a Review'}
      </Button>
    </ReviewModal>
  );
};

export default ReviewButton;
